const state = {
  type: null,
  group: null,
};

const actions = {
  setDragType(context, opts) {
    const type = typeof opts === 'string' ? opts : opts.type;
    const group = typeof opts === 'object' && opts.group;

    context.commit('SET_DRAG_TYPE', type);

    if (group) {
      context.commit('SET_DRAG_GROUP', group);
    } else {
      context.commit('SET_DRAG_GROUP', null);
    }
  },

  clearDragType(context) {
    context.commit('SET_DRAG_TYPE', null);
    context.commit('SET_DRAG_GROUP', null);
  },
};

const mutations = {
  /* eslint-disable no-param-reassign, no-shadow */

  SET_DRAG_TYPE(state, type) {
    state.type = type;
  },

  SET_DRAG_GROUP(state, val) {
    state.group = val;
  },
};

export default {
  state,
  actions,
  mutations,
};
